export const VOD_BASE_URL = "https://tvanywhereonline.com/cm"
export const ALT_BASE_URL = "https://ott.tvanywhereafrica.com:28182"
export const AUTH_BASE_URL = "https://tvanywhereonline.com/cm"
export const OPERATOR_UID = "afriplayghana"